//Provider Service 중 유저 정보 읽어오기
import axios from 'axios'

const campaign_users = {
    namespaced: true,
    state: {
        users_in_company : [
            
        ]
    },
    mutations: {
        update_users_in_company(state, new_users){
            state.users_in_company = new_users
        }
    },
    getters: {
    },
    actions: {
        readUsersByCompany( {commit, rootState}, company_id ){
            const path = rootState.backend_host + '/read_users_by_company'
            return axios.get(path, {params : {company_id: company_id}})
            .then(response => {
                // console.log(response.data.all_users);
                commit('update_users_in_company', response.data.all_users)
            })
            
        }

    }
}


export default campaign_users